import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { AttendeeSessionService } from "../../../../modules/shared/services/attendee-session.service";
import { CclPopupService, CclMessageService } from "certain-common-library";
import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from "@angular/router";
import { CatalogService } from "../../../../modules/shared/services/catalog.service";

@Component({
    selector: "login-popup",
    templateUrl: "./login-popup.view.html",
    providers: []
})
export class LoginPopupView implements OnInit {
    loginModal: any = {};
    loginConfig: any = {};
    isPopUp: boolean = false;
    constructor(
        private router: Router,
        public sharedService: SharedService,
        private attendeeSessionService: AttendeeSessionService,
        private popupService: CclPopupService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService
    ) {}
    ngOnInit() {
        this.isPopUp = this.router.url.includes("(popup:popup/login)");
        this.loginConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP].config);
        if(!('isForgotPasswordEnabled' in this.loginConfig.footer)) {
            this.loginConfig.footer.isForgotPasswordEnabled = false;
        }
    }

    closePopup() {}

    login() {
        if (this.sharedService.loggedInAttendee == null) {
            this.loginModal.eventId = this.sharedService.event.id;
            this.attendeeSessionService.login(this.loginModal).subscribe(
                (resp) => {
                    this.sharedService.loggedInAttendee = resp.body["registrationDTO"];
                    this.getAccountclient(this.sharedService.accountUUID);
                    sessionStorage.setItem(
                        "loggedInAttendee_" + this.sharedService.eventUUID,
                        JSON.stringify(this.sharedService.loggedInAttendee)
                    );
                    sessionStorage.setItem(
                        "regUUID_" + this.sharedService.eventUUID,
                        this.sharedService.loggedInAttendee.uuid
                    );
                    this.attendeeSessionService.getSessionApiOnLogin();
                    this.messageService.sendMessage("attendee-login");
                    this.popupService.hidePopup();

                    this.attendeeSessionService
                        .getCartData(this.sharedService.loggedInAttendee.uuid)
                        .subscribe((resp) => {
                            this.sharedService.cartData = resp.body;
                        });
                },
                (err) => {
                    var message = "";
                    if (err.error.errorResponse != null && err.error.errorResponse.errors != null) {
                        err.error.errorResponse.errors.forEach((element) => {
                            message += element + "\n";
                        });
                    }

                    this._flashMessagesService.show(message, {
                        cssClass: "alert-danger"
                    });
                }
            );
        }
    }

    getAccountclient(accountUUID) {
        this.catalogService.getAccountclient(accountUUID).subscribe((resp:any) => {
            this.sharedService.accountClientList = JSON.parse(resp.body.data);
        });
    }

    loginWithSSO(ssoId) {
        let ssoProfile =
            "/svcs/catalog_sso/handleRequest/" +
            ssoId +
            "?catalogUUID=" + this.sharedService.setup.uuid +
            "&destination=login";
        jQuery("#ssoForm").attr("action", ssoProfile);
        jQuery("#ssoForm").submit();
    }

    openSignupForm() {
        if (this.loginConfig.footer.formId != null && this.loginConfig.footer.formDTO != null) {
            let url = "/profile/form/index.cfm?PKformID=" + this.loginConfig.footer.formDTO.pkFormId;
            window.open(url, "_blank");
        }
    }

    close() {
        this.popupService.hidePopup();
    }

    openPopup(item, $event) {
        this.close();
        setTimeout(() => {
            if ($event != null) {
                $event.stopPropagation();
            }
            let url = "";
            if (item == "forgotpassword") {
                this.popupService.setPosition("center");
                this.popupService.setHeight("40%");
                this.popupService.setSize("small");
                this.popupService.togglePopup();
                this.sharedService.currentPopup = {
                    title: null,
                    navLinks: null,
                    saveMessage: "forgotpassword",
                    showFooter: false
                };
                url = "popup/forgotPassword";
            }
            this.sharedService.navigateToOutlet("popup", url);
        }, 500);
    }
}
